export default __webpack_public_path__ + "static/media/pop-up-ad.1a3f38dd.svg";